module.exports = __webpack_public_path__ + "videos/mts-products-chats-chats-and-channels.390ed88.mp4";